import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { motion } from 'framer-motion';

const BrandOne = () => {
    const [certifications, setCertifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const API_BASE_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        fetchCertifications();
    }, []);

    const fetchCertifications = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/certifications/`, {
                method: 'GET',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            let data = await response.json();

            if (Array.isArray(data)) {
                setCertifications(data);
            } else if (data.results && Array.isArray(data.results)) {
                setCertifications(data.results);
            } else if (data.data && Array.isArray(data.data)) {
                setCertifications(data.data);
            } else {
                setCertifications([]);
            }

            setLoading(false);
        } catch (error) {
            console.error('Error fetching certifications:', error);
            setCertifications([]);
            setLoading(false);
        }
    };

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} flex-center rounded-circle`}
                aria-label="Next"
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }

    function SamplePrevArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} flex-center rounded-circle`}
                aria-label="Previous"
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }

    const settings = {
        dots: false,
        arrows: true,
        infinite: certifications.length > 8,
        speed: 800,
        slidesToShow: 8,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            { breakpoint: 1599, settings: { slidesToShow: 7 } },
            { breakpoint: 1399, settings: { slidesToShow: 6 } },
            { breakpoint: 992, settings: { slidesToShow: 5 } },
            { breakpoint: 575, settings: { slidesToShow: 4 } },
            { breakpoint: 424, settings: { slidesToShow: 3 } },
            { breakpoint: 359, settings: { slidesToShow: 2 } },
        ],
    };

    if (loading) return null;
    if (certifications.length === 0) return null;

    return (
        <section className="brand">
            <div className="container container-lg">
                <motion.div
                    className="brand-inner"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                >
                    <div className="section-heading">
                        <div className="flex-between flex-wrap gap-8">
                            <h5 className="mb-0">Our Certifications & Trust</h5>
                        </div>
                    </div>
                    <motion.div
                        className="brand-slider"
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true }}
                        variants={{
                            hidden: { opacity: 0 },
                            show: {
                                opacity: 1,
                                transition: {
                                    staggerChildren: 0.1
                                }
                            }
                        }}
                    >
                        <Slider {...settings}>
                            {certifications.map((cert) => (
                                <motion.div
                                    key={cert.id}
                                    className="brand-item"
                                    variants={{
                                        hidden: { opacity: 0, scale: 0.8 },
                                        show: { opacity: 1, scale: 1 }
                                    }}
                                >
                                    <img
                                        src={cert.image}
                                        alt={`Certification ${cert.id}`}
                                        onError={(e) => {
                                            if (!e.target.src.includes('http')) {
                                                e.target.src = `${API_BASE_URL.replace('/api/v1', '')}${cert.image}`;
                                            }
                                        }}
                                    />
                                </motion.div>
                            ))}
                        </Slider>
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
};

export default BrandOne;
